/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicBranches.internal

import features.publicBranches.models.PublicBranchesModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class PublicBranchesRequest : NetworkRequest() {

    suspend fun getPublicBranches(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<PublicBranchesModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicBranchesEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
